import {FlaskConical} from 'lucide-react';
import React from 'react';

import {Tooltip, TooltipContent, TooltipTrigger} from '@/components/ui/tooltip.tsx';

type BetaViewSwitchProps = {
  betaView?: boolean;
  setBetaView?: (value: boolean) => void;
};

const BetaViewSwitch = ({betaView}: BetaViewSwitchProps) => {
  return (
    <div className='flex items-center justify-end gap-2 rounded-lg'>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className='flex items-center gap-2 bg-white shadow-sm rounded-md p-2'>
            <FlaskConical className={`w-4 h-4 ${betaView ? 'text-blue-500' : 'text-gray-400'}`}/>
            <span className='text-sm'>
              {`What's Next?`}
            </span>
            <button
              className="relative inline-flex h-5 w-9 flex-shrink-0 cursor-not-allowed rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none"
              disabled
              type="button"
            >
              <span
                className="translate-x-0 pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              />
            </button>
          </div>
        </TooltipTrigger>
        <TooltipContent side='bottom'>
          <p className='text-sm max-w-[250px] bg-gray-200 p-2 rounded-md'>
            Coming soon: A sneak peek into how AI handles your tasks with detailed logs.
          </p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default BetaViewSwitch;
